module.exports = "/assets/images/detective.png";